module.exports = __webpack_public_path__ + "static/media/aqua-net_dashboard.57d13411.png";